import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const defaultCategories = {
  MARKETING: 0,
  UTILITY: 0,
};

const DoughnutChart = ({ templateCategoryCount }) => {

  const counts = { ...defaultCategories, ...templateCategoryCount };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
      },
    },
  };
  const data = {
    labels: ["Marketing", "Utility"],
    datasets: [
      {
        label: "# of templates",
        data: [
          Number(counts.MARKETING) || 0,
          Number(counts.UTILITY) || 0,
        ],
        backgroundColor: ["#56cbf1", "#fdd974"],
        borderColor: ["#56cbf1", "#fdd974"],
        borderWidth: 1,
      },
    ],
  };
  return <Doughnut data={data} options={options} />;
};

export default DoughnutChart;
